module.exports = __webpack_public_path__ + "media/images/noticia02-ori-cccbdf5bc248ea5b16a1a8a2b904f041.jpg";